@if (imageUrl && !imageLoadError) {
  @if (preserveImage) {
    <!-- External photo (e.g. Google Business review) — keep original framing so
         any corner badge the source adds isn't clipped by our circle. -->
    <img
      class="preserve-image"
      [src]="imageUrl"
      [alt]="name"
      referrerpolicy="no-referrer"
      (error)="onImageError()"
    />
  } @else {
    <!-- Internal photo — clipped to a circle, no outline (the photo is the visual). -->
    <div
      class="circle circle-photo"
      [class.circle-sm]="size === 'sm'"
      [class.circle-md]="size === 'md'"
      [class.circle-lg]="size === 'lg'"
    >
      <img [src]="imageUrl" [alt]="name" referrerpolicy="no-referrer" (error)="onImageError()" />
    </div>
  }
} @else if (isDummy) {
  <div
    class="circle circle-silhouette"
    [class.circle-sm]="size === 'sm'"
    [class.circle-md]="size === 'md'"
    [class.circle-lg]="size === 'lg'"
    [ngStyle]="{ background: color }"
  >
    <!-- Inline silhouette so the component doesn't depend on an external asset path
         (apps like landing that adopt this component don't need to copy the SVG). -->
    <svg class="silhouette-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  </div>
} @else if (name && name.length > 0) {
  <div
    class="circle circle-initials"
    [class.circle-sm]="size === 'sm'"
    [class.circle-md]="size === 'md'"
    [class.circle-lg]="size === 'lg'"
    [ngStyle]="{ background: color }"
  >
    {{ name[0] | uppercase }}
  </div>
}
